/** Browser history helpers so in-app navigation works with Back/Forward. */

const PAGE_KEY = "imsPage";
const MODAL_KEY = "imsModal";

function currentUrl() {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
}

export function getAppHistoryPage(state = window.history.state) {
  return state?.[PAGE_KEY] ?? null;
}

export function getAppHistoryModal(state = window.history.state) {
  return state?.[MODAL_KEY] ?? null;
}

export function replaceAppHistory({ page, modal = null } = {}) {
  const next = { [PAGE_KEY]: page };
  if (modal) next[MODAL_KEY] = modal;
  window.history.replaceState(next, "", currentUrl());
}

export function pushAppHistory({ page, modal = null } = {}) {
  const next = { [PAGE_KEY]: page };
  if (modal) next[MODAL_KEY] = modal;
  window.history.pushState(next, "", currentUrl());
}

/**
 * Clear a modal layer from the current history entry (e.g. before leaving a page)
 * without adding a new entry.
 */
export function clearAppHistoryModal() {
  const page = getAppHistoryPage();
  if (!page || !getAppHistoryModal()) return;
  replaceAppHistory({ page });
}

/** Fired by in-app navigate so open overlays can dismiss without history.back(). */
export const APP_NAVIGATE_EVENT = "ims:navigate";

export function notifyAppNavigate() {
  window.dispatchEvent(new Event(APP_NAVIGATE_EVENT));
}
